import styled from "styled-components";
export var PAST_LIVE_CARD_CONTAINER_CLASSNAMES = 'flex flex-col rounded-5 overflow-hidden';
export var PastLiveCardContainer = /*#__PURE__*/styled.article.withConfig({
  componentId: "sc-17lr6bf-0"
})(["\n  height: 340px;\n"]);
export var PastLiveCardImageWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-17lr6bf-1"
})(["\n  height: 152px;\n"]);